import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import './i18n';

import Main from './components/Main';
import { PlaymakersOptionsProvider } from './store';

const Wrapper = ({ options: { rootingBaseUrl }, options }) => (
  <PlaymakersOptionsProvider options={options}>
    <BrowserRouter basename={rootingBaseUrl ?? '/playmakers'}>
      <Routes>
        <Route path='/' element={<Navigate replace to='en/' />} />
        <Route path=':locale' element={<Main />} />
      </Routes>
    </BrowserRouter>
  </PlaymakersOptionsProvider>
);

export default Wrapper;
